import React from "react";
import { styled, Stack, Typography, StackProps, Box, Link } from "@mui/material";
import { useTranslation } from "react-i18next";

export type EmptyListSlotProps = {
  title: string;
  desc?: string;
  closeButton?: () => void;
  icon?: React.ReactNode;
  CTA?: React.ReactNode;
} & StackProps;

const EmptyListSlot: React.FC<EmptyListSlotProps> = (props) => {
  const { children, title, desc, icon, CTA, closeButton, ...otherProps } = props;
  const { t } = useTranslation();

  return (
    <StyledStack justifyContent="center" alignItems="center" {...otherProps}>
      <Illustration>
        <img src="/static/images/empty-list.svg" alt="" width={51} height={41} />
        {icon}
      </Illustration>
      <Typography variant="subtitle1" fontWeight={500} component="h2">
        {title}
      </Typography>
      {desc && (
        <Typography color="text.tier" mt={0.5}>
          {desc}
        </Typography>
      )}

      {CTA && <Box mt={2}>{CTA}</Box>}

      {closeButton && (
        <Link underline="hover" color="text.primary" fontWeight={600} onClick={closeButton}>
          {t("common:close")}
        </Link>
      )}
    </StyledStack>
  );
};

export default EmptyListSlot;

const StyledStack = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: 6,
  background: theme.palette.background.paper,
}));

const Illustration = styled("figure")(({ theme }) => ({
  position: "relative",
  width: 72,
  height: 72,
  marginBottom: theme.spacing(3),
  borderRadius: "100%",
  background: "linear-gradient(180deg, rgba(247, 192, 53, 0) 0%, rgba(247, 192, 53, 0.17) 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  img: {
    position: "absolute",
    left: -10.5,
    top: -18,
  },
  ".MuiSvgIcon-root": {
    fontSize: 32,
  },
}));
